class TeamMember {
  constructor(data = {}) {
    this.id = data.id || data._id || null;
    this._id = data._id || data.id || null;
    this.projectId = data.projectId || null;
    this.employeeId = data.employeeId || null;
    this.role = data.role || 'Team Member';
    this.allocation = data.allocation || 100;
    this.joinedDate = data.joinedDate || new Date().toISOString().split('T')[0];
    this.leftDate = data.leftDate || null;
    this.status = data.status || 'Active';
    this.tasksAssigned = data.tasksAssigned || 0;
    this.tasksCompleted = data.tasksCompleted || 0;
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
  }

  getStatusColor() {
    const colors = { 
      'Active': '#10b981', 
      'Inactive': '#ef4444' 
    };
    return colors[this.status] || '#6b7280';
  }

  getCompletionRate() {
    if (this.tasksAssigned === 0) return 0;
    return Math.round((this.tasksCompleted / this.tasksAssigned) * 100);
  }

  getRoleColor() {
    const colors = {
      'Project Manager': '#8b5cf6',
      'Tech Lead': '#3b82f6',
      'Senior Developer': '#0ea5e9',
      'Developer': '#10b981',
      'Junior Developer': '#84cc16',
      'Designer': '#f59e0b',
      'QA Engineer': '#ef4444',
      'Business Analyst': '#ec4899',
      'Team Member': '#64748b'
    };
    return colors[this.role] || '#64748b';
  }

  isOverAllocated() {
    return this.allocation > 100;
  }

  isActive() {
    return this.status === 'Active';
  }

  getDaysInProject() {
    if (!this.joinedDate) return 0;
    const endDate = this.leftDate ? new Date(this.leftDate) : new Date();
    const startDate = new Date(this.joinedDate);
    return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
  }

  validate() {
    const errors = [];
    
    if (!this.projectId) {
      errors.push('Project required');
    }
    
    if (!this.employeeId) {
      errors.push('Employee required');
    }
    
    if (this.allocation < 0 || this.allocation > 100) {
      errors.push('Allocation must be between 0-100%');
    }
    
    if (!this.role) {
      errors.push('Role is required');
    }
    
    if (!this.joinedDate) {
      errors.push('Joined date is required');
    }
    
    if (this.leftDate && this.joinedDate) {
      if (new Date(this.leftDate) < new Date(this.joinedDate)) {
        errors.push('Left date cannot be before joined date');
      }
    }
    
    return { 
      isValid: errors.length === 0, 
      errors 
    };
  }

  toJSON() {
    return {
      id: this.id,
      _id: this._id,
      projectId: this.projectId,
      employeeId: this.employeeId,
      role: this.role,
      allocation: this.allocation,
      joinedDate: this.joinedDate,
      leftDate: this.leftDate,
      status: this.status,
      tasksAssigned: this.tasksAssigned,
      tasksCompleted: this.tasksCompleted,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  static fromJSON(json) {
    return new TeamMember(json);
  }
}

export default TeamMember;